import React, { useState, useEffect, useMemo } from "react";
import LeaveLayout from "../../components/LeaveLayout.jsx";
import { LuCalendarMinus, LuCalendarPlus } from "react-icons/lu";
import {
  MdAddCircle,
  MdArrowForward,
  MdArrowBack,
  MdDashboard,
} from "react-icons/md";
import { Button, Col, Dropdown, Form } from "react-bootstrap";
import { IoMdAdd } from "react-icons/io";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./leave.css";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import axios from '../../Authservices/axiosInstance';
export default function Leave() {
  const [showDialog, setShowDialog] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedTab, setSelectedTab] = useState(null);
  const [showTabs, setShowTabs] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startLeaveDate, setStartLeaveDate] = useState(null);
  const [endLeaveDate, setEndLeaveDate] = useState(null);
  const [dateSelected, setDateSelected] = useState(false);
  const [value, setTabValue] = useState(0);
  const rowsPerPage = 10;
  const [currentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState("");
  const [showErrors] = useState(false);
  const [users, setUsers] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [searchQuery] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [tableData, setTableData] = useState([]);
  const [image, setImage] = useState(null);
  const [fileName, setFileName] = useState("No file chosen");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setImage(file); // Store actual file object for upload
    }
  };
  const handleChange = (event, newValue) => {
    setTabValue(newValue); // Update tabValue when user switches tabs
  };
  const handleButtonClick = () => {
    setShowDialog((prev) => !prev);
    setDateSelected(false); // Reset date selection when dialog opens
  };
  const handleDateChange = (direction) => {
    const newDate = new Date(currentDate);
    if (direction === "forward") {
      newDate.setDate(currentDate.getDate() + 1);
    } else if (direction === "backward") {
      newDate.setDate(currentDate.getDate() - 1);
    }
    setCurrentDate(newDate);
  };
  const handleTabToggle = () => {
    setShowTabs((prev) => !prev);
  };
  const handleTabSelect = (tab) => {
    setSelectedTab(tab);
    setShowTabs(false);
  };
  const leaveTypes = [
    "Holiday",
    "Sick",
    "Vacation",
    "Public Holiday",
    "Maternity",
    "Paternity",
    "Parental",
    "Study Leave",
    "Other Leave",
  ];
  // Function to format date and time
  const formatDateTime = (date) => {
    if (!date) return "-";
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return new Intl.DateTimeFormat("en-US", options).format(new Date(date));
  };
  function LinkTab(props) {
    return (
      <Tab
        component="a"
        onClick={(event) => {
          event.preventDefault();
        }}
        {...props}
      />
    );
  }

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(
          "https://backend.ems.uk.hiradentallab.com/api/user/getAllUsers"
        );
        if (!response.ok) {
          throw new Error("Failed to fetch users");
        }
        const data = await response.json();
        setUsers(data); // Update state with fetched users
      } catch (error) {
        console.error("Error fetching users:", error);
        alert("Failed to fetch user data. Please try again.");
      } finally {
        setLoading(false); // Stop loading after fetching data
      }
    };
    fetchUsers();
  }, []);
  const handleAddLeave = async () => {
    try {
      const role = localStorage.getItem("role") || "admin";
  
      const selectedUserData = users.find((user) => user.username === selectedUser);
      if (!selectedUserData) {
        alert("Please select a valid user.");
        return;
      }
  
      const formData = new FormData();
      formData.append("userId", selectedUserData.userId);
      formData.append("username", selectedUserData.username);
      formData.append("name", selectedUserData.name);
      formData.append("leaveType", selectedTab);
      formData.append("startDate", startLeaveDate);
      formData.append("endDate", endLeaveDate);
      formData.append("paidStatus", value === 0 ? "Paid" : "UnPaid");
      formData.append("reason", document.querySelector(".reason-textarea").value);
      formData.append("role", role);
  
      if (image) {
        formData.append("document", image); // Attach selected file
      }
  
      const response = await fetch("https://backend.ems.uk.hiradentallab.com/api/leaves/add-leave/admin", {
        method: "POST",
        body: formData,
      });
  
      const data = await response.json();
  
      if (response.ok) {
        alert(`Leave added successfully: ${data.message}`);
      } else {
        alert(`Error: ${data.error}`);
      }
    } catch (error) {
      console.error("Failed to add leave:", error);
      alert("Something went wrong. Please try again.");
    }
  };
  
  const handleGenerateReport = async () => {
    if (startDate && endDate) {
      setFormErrors({});
      try {
        const response = await axios.get(
          "https://backend.ems.uk.hiradentallab.com/api/leaves/leaves/reports",
          {
            params: {
              startDate: startDate.toISOString().split("T")[0],
              endDate: endDate.toISOString().split("T")[0],
            },
          }
        );
        setTableData(response.data.leaves);
        setShowTable(true);
      } catch (error) {
        console.error("Error fetching leave data:", error);
        alert("Failed to fetch leave data. Please try again.");
        setShowTable(false);
      }
    } else {
      setFormErrors({
        startDate: !startDate ? "Start date is required" : "",
        endDate: !endDate ? "End date is required" : "",
      });
      setShowTable(false);
    }
  };
  const filteredData = useMemo(() => {
    return tableData.filter(
      (row) =>
        row.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        row.leaveType.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [searchQuery, tableData]);
  const currentRows = useMemo(() => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    return filteredData.slice(startIndex, startIndex + rowsPerPage);
  }, [currentPage, filteredData]);
  return (
    <LeaveLayout>
      <div>
        <div className="leave-header">
          <h1 className="leave-title">
            <LuCalendarMinus /> Leave
          </h1>
          <Button className="add-leaves-btn" onClick={handleButtonClick}>
            <MdAddCircle className="add-icon" />
          </Button>
          <div className="date-selector">
            <button
              className="date-nav-btn"
              onClick={() => handleDateChange("backward")}
            >
              <MdArrowBack />
            </button>
            <span className="date-display">{currentDate.toDateString()}</span>
            <button
              className="date-nav-btn"
              onClick={() => handleDateChange("forward")}
            >
              <MdArrowForward />
            </button>
          </div>
        </div>
        <hr />
        <div className="leave-table-container">
          <div className="filter-container">
            <Col xs={12} md={6} className="filter-left">
              <Dropdown className="d-inline mx-2" autoClose="inside">
                <Dropdown.Toggle id="dropdown-autoclose-inside">
                  Show Entries
                </Dropdown.Toggle>
                <Dropdown.Menu className="custom-dropdown-menu">
                  <Dropdown.Item href="#">15</Dropdown.Item>
                  <Dropdown.Item href="#">25</Dropdown.Item>
                  <Dropdown.Item href="#">50</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="filter-right">
              <Form className="d-flex">
                <Form.Control
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                  className="depts-search-bar"
                  // Update search query dynamically
                />
              </Form>
            </Col>
          </div>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <table className="table table-striped leave-table">
              <thead className="table-header">
                <tr className="leave-table-header">
                  <th>SR</th>
                  <th>Employee Name</th>
                  <th>Used Holidays</th>
                  <th>Remaining Holidays</th>
                  <th>Yearly Holidays</th>
                  <th>Pay Per Holiday</th>
                </tr>
              </thead>
              <tbody>
                {users.slice(0).map((user, index) => (
                  <tr key={user.id || index}>
                    <td>{index + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.usedHolidays || "N/A"}</td>
                    <td>{user.remainingLeaves || "N/A"}</td>
                    <td>{user.yearlyLeaves || "N/A"}</td>
                    <td>{user.payPerHoliday || "N/A"}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-footer">
                <tr className="leave-table-footer">
                  <td>Total</td>
                  <td>-</td>
                  <td>0</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>
        <div
  className={`slide-dialog ${showDialog ? "slide-dialog-open" : ""}`}
  style={{
    overflowY: "auto", // Enables scrolling if content overflows

  }}
>
  <div className="dialog">
    <div className={`left-section ${dateSelected ? "hidden" : ""}`}>
      <div className="dialog-header">
        <h2 className="dialog-title">
          <LuCalendarPlus /> Add Leave
        </h2>
        <Button className="submit" onClick={handleAddLeave}>
          <IoMdAdd /> Add Leave
        </Button>
      </div>
      <hr className="dialog-divider" />
      <Form.Select
        style={{ width: "100%" }}
        name="username"
        required
        value={selectedUser}
        onChange={(e) => setSelectedUser(e.target.value)}
        className="form-control fancy-select"
        isInvalid={showErrors && !selectedUser}
      >
        <option value="">Select a Username</option>
        {users.map((user) => (
          <option key={user._id} value={user.username}>
            {user.username}
          </option>
        ))}
      </Form.Select>

      <div className="tab-container">
        <div className="tab-header" onClick={handleTabToggle}>
          <div className="tab-icon">
            <MdDashboard className="dashboard-icon" />
            <span className="tab-heading">
              {selectedTab
                ? `--${selectedTab.replace(/([A-Z])/g, " $1").trim()}--`
                : "--Leave Type--"}
            </span>
          </div>
          <div
            className={`tab-dropdown ${
              showTabs ? "tab-dropdown-open" : ""
            }`}
          >
            {leaveTypes.map((tab) => (
              <div
                key={tab}
                className={`tab-item ${
                  selectedTab === tab ? "selected" : ""
                }`}
                onClick={() => handleTabSelect(tab)}
              >
                {tab}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="date-picker-container">
        <div className="date-picker-wrapper">
          <DatePicker
            selected={startLeaveDate}
            onChange={(date) => setStartLeaveDate(date)}
            id="start-date"
            className="date-picker"
            placeholderText="Select a start date for adding a leave"
          />
        </div>
        <div className="date-picker-wrapper">
          <DatePicker
            selected={endLeaveDate}
            onChange={(date) => setEndLeaveDate(date)}
            id="end-date"
            className="date-picker"
            placeholderText="Select an end date for adding a leave"
          />
        </div>
      </div>

      <div className="date-picker-container">
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          placeholderText="Select Start Date"
          className="date-picker"
          isInvalid={!!formErrors?.startDate}
        />
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          placeholderText="Select End Date"
          className="date-picker"
          isInvalid={!!formErrors?.endDate}
        />
        <button className="submit" onClick={handleGenerateReport}>
          Leave Lookup
        </button>
      </div>

      <div className="payment-tab-container">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="nav tabs example"
          role="navigation"
          className="payment-tab"
        >
          <LinkTab label="Paid" href="/drafts" />
          <LinkTab label="UnPaid" href="/trash" />
        </Tabs>
      </div>

      <div className="reason-container">
        <h3 className="reason-title">Message (Optional)</h3>
        <p>Visible to the employee</p>
        <textarea
          className="reason-textarea"
          placeholder="----"
          style={{ width: "100%" }}
        />

<div className="file-upload-container">
          <label htmlFor="file-upload" className="custom-file-label">
           Add Document
            <input
              type="file"
              id="file-upload"
              accept="image/*"
              className="file-upload-input"
              onChange={handleFileChange}
            />
          </label>
          <span className="file-name">{fileName}</span>
        </div>
      </div>
 
            </div>
            {showTable && (
              <div className={`right-section`}>
                <div className="people-on-leave-table-container">
                  <h6
                    style={{
                      fontWeight: "bolder",
                      color: "#0353a4",
                      fontSize: "1.5rem",
                    }}
                  >
                    Selected Date Leaves
                  </h6>
                  <table className="people-on-leave-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Leave Type</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRows.length > 0 ? (
                        currentRows.map((row, index) => (
                          <tr key={index}>
                            <td>{row.name}</td>
                            <td>{row.leaveType}</td>
                            <td>{formatDateTime(row.startDate)}</td>
                            <td>{formatDateTime(row.endDate)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4">
                            No people on leave during the selected period.
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot className="table-footer">
                      <tr className="leave-table-footer">
                        <td>Total</td>
                        <td>-</td>
                        <td>{currentRows.length}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </LeaveLayout>
  );
}
